import type { Rect } from '@/types/ainotebook'

export function hasRealChars(s: string) {
  return /[A-Za-z0-9\u4e00-\u9fff\u3040-\u30ff\uac00-\ud7af]/.test(s)
}

export function isLikelyPdfNoise(text: string, rect: Rect) {
  const t = text.trim()
  const compactLen = t.replace(/\s+/g, '').length
  if (compactLen <= 12 && rect.w >= rect.h * 18) return true
  if (!hasRealChars(t)) return true
  return false
}

export function isInImageAreaLikelyNoise(text: string, rect: Rect, pageH: number) {
  const cy = rect.y + rect.h / 2
  if (cy < pageH * 0.55 && text.trim().length <= 10) return true
  return false
}

export function isLongThinBar(rect: Rect, pageW: number, pageH: number) {
  const ar = rect.w / Math.max(1, rect.h)
  const nearFullWidth = rect.w > pageW * 0.45
  const veryThin = rect.h < pageH * 0.03
  return ar > 18 && nearFullWidth && veryThin
}

export function isGhostTextBar(text: string, rect: Rect, pageW: number, pageH: number) {
  const compact = text.replace(/\s+/g, '')
  const len = compact.length
  const ar = rect.w / Math.max(1, rect.h)
  const avgW = rect.w / Math.max(1, len)

  if (len <= 12 && rect.w > pageW * 0.32 && rect.h < pageH * 0.08 && ar > 10) return true
  if (len <= 12 && rect.w > pageW * 0.25 && avgW > rect.h * 3.0) return true

  const cy = rect.y + rect.h / 2
  if (cy < pageH * 0.62 && len <= 10) return true

  if (isLikelyPdfNoise(text, rect)) return true
  return false
}
